import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import ProcessMapView from '../components/View/ProcessMapView';

const ProcessMapViewBridge = react2angular(ProcessMapView, ['processMapId']);

export default ProcessMapViewBridge;
